"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactCardTypeRampVariants = exports.contactCardTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const contactCardTheme = (0, _sdsThemeInternal.themed)({
  actionButtonSize: {
    "lodestar-light": "large",
    "ursa-light": "medium"
  },
  actionButtonAppearance: {
    "lodestar-light": "borderless",
    "ursa-light": "primary-empty"
  },
  actionButtonLeftOffset: {
    "lodestar-light": `-${_designTokens.space.space10}`,
    "ursa-light": `-${_designTokens.space.space30}`
  },
  borderRadius: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius30
  },
  shadow: {
    "lodestar-light": "0px 4px 16px rgba(0, 0, 0, 0.12)",
    "ursa-light": (0, _designTokensReact.color)("elevation--low")
  },
  fontSize: {
    "lodestar-light": 13,
    "ursa-light": 14
  },
  colors: {
    background: (0, _designTokensReact.color)("color--background--surfaces--work"),
    name: (0, _designTokensReact.color)("color--text--neutral--strong"),
    detailItem: (0, _designTokensReact.color)("color--icons--neutral--stronger"),
    infoItem: (0, _designTokensReact.color)("color--icons--spectrum-neutral--default")
  },
  lineSeparation: {
    "lodestar-light": "0",
    "ursa-light": "2px"
  }
});
exports.contactCardTheme = contactCardTheme;
const contactCardTypeRampVariants = {
  name: {
    oldestar: {
      system: "lodestar",
      variant: "headerLarge"
    },
    "lodestar-light": {
      system: "lodestar",
      variant: "headerLarge"
    },
    "ursa-light": {
      system: "ursa",
      variant: "Inter--16px--600w"
    }
  },
  detailItem: {
    oldestar: {
      system: "lodestar",
      variant: "metadata"
    },
    "lodestar-light": {
      system: "lodestar",
      variant: "metadata"
    },
    "ursa-light": {
      system: "ursa",
      variant: "Inter--14px--400w"
    }
  },
  infoItem: {
    oldestar: {
      system: "lodestar",
      variant: "body"
    },
    "lodestar-light": {
      system: "lodestar",
      variant: "body"
    },
    "ursa-light": {
      system: "ursa",
      variant: "Inter--14px--400w"
    }
  },
  cardHeader: {
    oldestar: {
      system: "lodestar",
      variant: "headerSmall"
    },
    "lodestar-light": {
      system: "lodestar",
      variant: "headerSmall"
    },
    "ursa-light": {
      system: "ursa",
      variant: "Inter--14px--700w"
    }
  }
};
exports.contactCardTypeRampVariants = contactCardTypeRampVariants;
//# sourceMappingURL=contactCardTheme.js.map